import Input from "../Input/Input";
import SendMessageSvg from "../../assets/send_message.svg";

import SendMessageStyles from "./SendMessage.module.scss";

const SendMessage = () => {
  const handleOnChange = (value: string) => {};
  return (
    <div className={SendMessageStyles.sendMessageContainer}>
      <Input
        handlers={{
          onChange: handleOnChange,
        }}
        inputText="Can you assist me with contract redlining review"
        disabled={true}
        actionBtns={
          <div className={SendMessageStyles.actionBtnsContainer}>
            <div className={SendMessageStyles.actionBtn}>
              <img src={SendMessageSvg} alt="" height={16} width={20} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default SendMessage;
